import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: 'AIzaSyCQf_5TxpR-sbMv0ruAZAf33kMAl1HT0r8',
  authDomain: 'klosy-store.firebaseapp.com',
  databaseURL: 'https://klosy-store.firebaseio.com',
  projectId: 'klosy-store',
  storageBucket: 'klosy-store.appspot.com',
  messagingSenderId: '1018085283404',
  appId: 'project-1018085283404',
}

export const firebaseApp = initializeApp(firebaseConfig)
